var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluePin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.492,
    height: 27.317,
    viewBox: "0 0 13.492 27.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-head2",
    cx: 0.27,
    cy: 0.243,
    r: 0.793,
    gradientTransform: "translate(0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5892cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#4f8bc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4784c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3e7dc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#3576bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#2b70b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#2069b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1362b0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-222",
    cx: 0.24,
    cy: 0.582,
    r: 0.623,
    gradientTransform: "matrix(0.708, -0.707, 0.381, 0.38, -49.316, -18.005)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Pin",
    transform: "translate(-0.71 0)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794",
    "data-name": "Group 2794",
    transform: "translate(0 23.103)",
    opacity: 0.204,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M2.51,63.877c0-.925,2.167-1.677,4.845-1.677s4.841.755,4.841,1.677-2.167,1.677-4.841,1.677S2.51,64.8,2.51,63.877Z",
    transform: "translate(-1.8 -61.339)",
    fill: "#898989",
    opacity: 0.234
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M2.72,64.036c0-.876,2.05-1.586,4.58-1.586s4.588.71,4.588,1.586-2.05,1.582-4.577,1.582S2.72,64.923,2.72,64.036Z",
    transform: "translate(-1.931 -61.495)",
    fill: "gray",
    opacity: 0.234
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M2.93,64.2c0-.823,1.93-1.488,4.312-1.488s4.312.665,4.312,1.488-1.93,1.488-4.312,1.488S2.93,65.021,2.93,64.2Z",
    transform: "translate(-2.062 -61.656)",
    fill: "#767676",
    opacity: 0.234
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M3.14,64.357c0-.755,1.813-1.4,4.048-1.4s4.044.623,4.044,1.4S9.42,65.75,7.188,65.75,3.14,65.127,3.14,64.357Z",
    transform: "translate(-2.192 -61.812)",
    fill: "#6c6c6c",
    opacity: 0.234
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M3.35,64.513c0-.717,1.692-1.3,3.776-1.3s3.776.585,3.776,1.3-1.692,1.3-3.776,1.3S3.35,65.234,3.35,64.513Z",
    transform: "translate(-2.323 -61.968)",
    fill: "#626262",
    opacity: 0.234
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M3.56,64.672c0-.668,1.575-1.212,3.516-1.212s3.512.544,3.512,1.212S9.016,65.88,7.076,65.88,3.56,65.34,3.56,64.672Z",
    transform: "translate(-2.454 -62.123)",
    fill: "#585858",
    opacity: 0.234
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M3.77,64.8c0-.615,1.454-1.133,3.247-1.133s3.259.5,3.259,1.133-1.458,1.133-3.251,1.133S3.77,65.418,3.77,64.8Z",
    transform: "translate(-2.584 -62.254)",
    fill: "#4e4e4e",
    opacity: 0.234
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M4,65.012C4,64.446,5.325,64,6.976,64s2.983.457,2.983,1.023-1.337,1.023-2.983,1.023S4,65.575,4,65.012Z",
    transform: "translate(-2.727 -62.459)",
    fill: "#454545",
    opacity: 0.234
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M4.19,65.149c0-.514,1.216-.929,2.719-.929s2.715.415,2.715.929-1.216.929-2.715.929S4.19,65.647,4.19,65.149Z",
    transform: "translate(-2.846 -62.596)",
    fill: "#3b3b3b",
    opacity: 0.234
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M4.4,65.315c0-.461,1.1-.835,2.451-.835s2.451.378,2.451.835-1.1.835-2.451.835S4.4,65.775,4.4,65.315Z",
    transform: "translate(-2.976 -62.758)",
    fill: "#313131",
    opacity: 0.234
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M4.61,65.445c0-.408.978-.755,2.186-.755s2.186.332,2.186.755S8,66.2,6.8,66.2,4.61,65.857,4.61,65.445Z",
    transform: "translate(-3.107 -62.889)",
    fill: "#272727",
    opacity: 0.234
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M4.82,65.629c0-.378.857-.649,1.918-.649s1.926.291,1.926.649-.861.649-1.922.649S4.82,65.988,4.82,65.629Z",
    transform: "translate(-3.238 -63.069)",
    fill: "#1d1d1d",
    opacity: 0.234
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M5,65.785c0-.306.755-.555,1.654-.555s1.654.249,1.654.555-.755.559-1.654.559S5,66.095,5,65.785Z",
    transform: "translate(-3.35 -63.225)",
    fill: "#141414",
    opacity: 0.234
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M5.24,65.951c0-.253.619-.461,1.386-.461s1.39.208,1.39.461-.623.461-1.39.461S5.24,66.207,5.24,65.951Z",
    transform: "translate(-3.499 -63.387)",
    fill: "#0a0a0a",
    opacity: 0.234
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M5.45,66.1c0-.2.5-.378,1.133-.378s1.133.166,1.133.378-.5.378-1.133.378S5.45,66.3,5.45,66.1Z",
    transform: "translate(-3.63 -63.53)",
    opacity: 0.234
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M4.19,32.6,9.537,12.631l-1.3-.351L2.876,32.353l-.076.211a.9.9,0,0,0,.023.2.687.687,0,0,0,.846.468.7.7,0,0,0,.446-.378V32.8Z",
    transform: "translate(-0.47 -7.635)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M14.4,6a6.019,6.019,0,1,0-6.015,6.019A6.019,6.019,0,0,0,14.4,6Z",
    transform: "translate(-0.196 0.02)",
    fill: "url(#radial-gradient-head2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M8.912,1c.717.714.223,2.368-1.1,3.689s-2.979,1.82-3.693,1.1S3.9,3.438,5.223,2.1,8.2.285,8.912,1Z",
    transform: "translate(-1.088 -0.409)",
    opacity: 0.6,
    fill: "url(#radial-gradient-222)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePin);
export default __webpack_public_path__ + "static/media/BluePin.2ef41fa6b57f45b1d837da9bcc7bd42a.svg";
export { ForwardRef as ReactComponent };